/**
 * 点检记录
 */
 import http from '@/http'

 export default {
   // 点检记录列表
   getRecordList(params) {
     return http.get('/asset/tpm/record', {params})
   },
   // 点检记录统计信息
   getRecordStatistics(params) {
    return http.get('/asset/tpm/statistics', {params})
  },
  // 作废
  invalidRecord(params) {
    return http.post('/asset/tpm/cancel', params)
  },
  // 查询详情
  getRecordDetail(id) {
    return http.get(`/asset/tpm/record/${id}`)
  },
  // 编辑并保存已有点检记录
  editRecord(params) {
    return http.put('/asset/tpm/record/edit', params)
  },
  // 非关键工具点检记录列表
  getNonkeyRecordList(params) {
    return http.get('/non-asset/tpm/record', {params})
  },
  // 非关键工具点检记录统计信息
  getNonkeyRecordStatistics(params) {
    return http.get('/non-asset/tpm/statistics', {params})
  },
  // 非关键工具点检记录详情
  getNonkeyRecordDetail(id) {
    return http.get(`/non-asset/tpm/record/${id}`)
  },
  // 编辑并保存已有非关键工具点检记录
  editNonkeyRecord(params) {
    return http.put('/non-asset/tpm/record/edit', params)
  },
  // 关键工具点检记录 批量逻辑删除
  batchDeleteAssetRecord(params) {
    return http.post('/asset/tpm/record/batch-delete', params)
  },
  // 非关键工具点检记录 批量逻辑删除
  batchDeleteNonAssetRecord(params) {
    return http.post('/non-asset/tpm/record/batch-delete', params)
  },
  // 点检确检记录-列表
  getTpmConfirmList(params) {
    return http.get('/tpm/confirm/task/admin/page', {params})
  },
  // 点检确检记录-批量删除
  deleteTpmConfirmBatch(params) {
    return http.post('/tpm/confirm/task/admin/batch-delete', params)
  },
  // 点检确检记录-统计
  getTpmConfirmStatistics(params) {
    return http.get('/tpm/confirm/task/admin/statistics', {params})
  },
  // 点检确检记录-详情
  getTpmConfirmDetail(id) {
    return http.get(`/tpm/confirm/task/admin/${id}`)
  }
}
